'use client';

import { useCallback } from 'react';

import { Typography, TypographyProps } from '../Typography';

import { StyledTab } from './styled';
import { TabProps } from './types';

export const Tab = (props: TabProps) => {
  const { label, size = 'small', ...rest } = props;

  const renderTypography = useCallback(() => {
    let variant: TypographyProps['variant'] = 'title1';

    if (size === 'large') {
      variant = 'title1';
    }

    if (size === 'medium') {
      variant = 'button4';
    }

    if (size === 'small') {
      variant = 'body7';
    }

    return (
      <Typography color="inherit" variant={variant} component="div">
        {label}
      </Typography>
    );
  }, [size, label]);

  return <StyledTab label={renderTypography()} size={size} {...rest} />;
};
